import React, { useState } from "react";
import Cookies from "js-cookie";
import socket from "../../socket";
import LoginUI from "../components/LoginUI";

const URL = process.env.REACT_APP_API_URL;

export default function Login({ onLoginSuccess }) {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false)
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${URL}/api/users/login/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, password })
      });

      if (!res.ok) throw new Error("Login failed");

      const data = await res.json();
      Cookies.set('user', JSON.stringify(data), { expires: 0.5 });
      if (data.empresa_id) {
        socket.emit("join_empresa", data.empresa_id);
        console.log("🟢 Unido a sala empresa desde login:", data.empresa_id);
      }
      onLoginSuccess();
    } catch (err) {
      setError(true);
      setName('');
      setPassword('');
    }
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    if (error) setError(false);
  };
  
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) setError(false);
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  }

  return (
    <LoginUI
      name={name}
      password={password}
      error={error}
      showPassword={showPassword}
      onNameChange={handleNameChange}
      onPasswordChange={handlePasswordChange}
      onSubmit={handleSubmit}
      handleShowPassword={handleShowPassword}
    />
  );
}
